import { render, staticRenderFns } from "./DatabaseIcon.vue?vue&type=template&id=59d1d074&scoped=true&"
import script from "./DatabaseIcon.vue?vue&type=script&lang=js&"
export * from "./DatabaseIcon.vue?vue&type=script&lang=js&"
import style0 from "./DatabaseIcon.vue?vue&type=style&index=0&id=59d1d074&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d1d074",
  null
  
)

export default component.exports